import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { xosoService } from "@/services/xosoService";
import { REGION_ORDER } from "./constants";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

const FETCHERS = {
  MB: (params) => xosoService.getXsmb(params),
  MN: (params) => xosoService.getXsmn(params),
  MT: (params) => xosoService.getXsmt(params),
};

const emptyPack = () => ({ MB: [], MN: [], MT: [] });

export default function useLotteryResults(date, regions = REGION_ORDER) {
  const [results, setResults] = useState(emptyPack);
  const [loading, setLoading] = useState(true);
  const regionKey = regions.join(",");

  useEffect(() => {
    if (!date) return undefined;
    let cancelled = false;
    setLoading(true);

    (async () => {
      const today = dayjs().tz(TZ).format("YYYY-MM-DD");
      const pack = emptyPack();
      await Promise.all(
        regions.map(async (region) => {
          let data = await FETCHERS[region]({ date });
          if (!data.length && date === today) {
            data = await FETCHERS[region]({});
          }
          pack[region] = data;
        })
      );

      if (!cancelled) {
        setResults(pack);
        setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [date, regionKey]);

  return { results, loading };
}
